module.exports = __webpack_public_path__ + "static/media/ath.fffcdd62.png";